module.exports = __webpack_public_path__ + "img/denied.0b5e1c85.svg";